import { Client, Databases, Account, Teams, Functions, ID, Query, Permission, Role, TablesDB } from 'appwrite';

const client = new Client();

const PROJECT_ID = process.env.REACT_APP_PROJECT_ID;
const ENDPOINT = process.env.REACT_APP_ENDPOINT;

client
    .setEndpoint(ENDPOINT)
    .setProject(PROJECT_ID);

const databases = new Databases(client);
const account = new Account(client);
const teams = new Teams(client);
const functions = new Functions(client);
const tablesDB = new TablesDB(client);

export { client, databases, account, teams, functions, tablesDB, ID, Query, Permission, Role };

